// Отправка событий в GTM. Если контейнер ещё не загружен, события копятся
// в dataLayer и будут обработаны после его инициализации.
export function trackEvent(event, params = {}) {
  if (typeof window === 'undefined') return;

  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch (e) {
    console.error('Analytics event failed:', e);
  }
}
